<div class="reference_body">
  <main class=" container-fluid">
    <div class="pink_box"></div>
    <div class="green_box"></div>

    <div class="main">

      <div class="reference_table">

        <div class="gmou" style="display: flex; flex-direction: column;">
          <div class="the_header_progress">
            <div class="rows">

               <div class="pull-left">
                <h3 class="header">Project Progress</h3>
               </div>

                <div class=" pull-right">
                  <mat-button-toggle-group name="fontStyle" aria-label="Font Style" color="accent" class="m-3">

                    <mat-button-toggle value="grid" routerLink="/project"><mat-icon class="example-tab-icon">arrow_back</mat-icon> Back</mat-button-toggle>
                    <mat-button-toggle mat-raised-button value="grid" color="primary" (click)="filterProjectModal()"><mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</mat-button-toggle>
                  </mat-button-toggle-group>
                  <!-- <button mat-raised-button color="primary"  (click)="filterProjectModal()"> <mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</button> -->
                 </div>

            </div>
          </div>

      <div>
        <mat-card>
          <mat-accordion>

            <mat-expansion-panel  hideToggle #example2 [expanded]="isExpanded" class="mat-elevation-z0">
  <mat-expansion-panel-header class="mat-expan">
  <mat-panel-title >
  <h3 class="header"> Project Progress</h3>
  </mat-panel-title>
  <!-- <mat-button-toggle-group name="fontStyle" aria-label="Font Style" color="accent" class="m-3">

    <mat-button-toggle value="grid" ><mat-icon class="example-tab-icon">arrow_back</mat-icon> Back</mat-button-toggle>
    <mat-button-toggle mat-raised-button value="grid" color="primary" (click)="filterProjectModal()"><mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</mat-button-toggle>
  </mat-button-toggle-group> -->
  <!-- <button mat-raised-button  (click)="filterProjectModal()"> <mat-icon class="example-tab-icon">filter_list</mat-icon> Filter Project</button> -->

  <mat-icon *ngIf="!example2.expanded">keyboard_arrow_down</mat-icon>
  <mat-icon *ngIf="example2.expanded">keyboard_arrow_right</mat-icon>


  </mat-expansion-panel-header>
  <div class="the_header">
  <div class="row">

    <div class="col-md-12">
      <div class="filter_button pull-right mr-5">

       </div>
    </div>
  </div>
  </div>
  <div class="monitor_project_drop">
  <div class="other_details" *ngIf="status" [@fadeInAnimation]>
    <div class="the_card the__detail-card">
      <div class="detail__info">
        <h4 class="label">
            <span class="labels" style="display: block;">State</span>
            <span class="the__input" *ngFor="let data of ProjectData?.States">
              {{data?.StateName}}
            </span>
        </h4>
    </div>
    <div class="detail__info">
        <h4 class="label">
            <span class="labels" style="display: block;">LGA</span>
            <span class="the__input" *ngFor="let data of ProjectData?.Lgas">
              {{data?.LgaName}}
               </span>
        </h4>
    </div>
    <div class="detail__info">
        <h4 class="label">
            <span class="labels" style="display: block;" *ngIf="genericBlockLabel">{{genericBlockLabel}}</span>
            <span class="the__input" *ngFor="let oilBlock of ProjectData?.OilBlocks">
              {{oilBlock?.OilBlockName}}
              </span>
        </h4>
    </div>
    <div class="detail__info">
        <h4 class="label">
            <span class="labels" style="display: block;" *ngIf="genericFieldLabel">{{genericFieldLabel}}</span>
            <span class="the__input" *ngFor="let oilField of ProjectData?.OilFields">
              {{oilField?.OilFieldName}}
            </span>
        </h4>
    </div>
    </div>

    <h4 class="description">
      <span class="label">Project description</span>
      <span class="described">{{ProjectData?.Description}}</span>
  </h4>

  <div class="detail__info">
      <h4 class="label">
          <span class="labels" style="display: block;">Project executor</span>
          <span class="the_input">{{ProjectData?.Executor}}</span>
      </h4>
  </div>
  <div class="detail__info">
      <h4 class="label">
          <span class="labels" style="display: block;">Start date</span>
          <span class="the_input">{{ProjectData?.StartDate | date}}</span>
      </h4>
  </div>
  <div class="detail__info">
      <h4 class="label">
          <span class="labels" style="display: block;">End date</span>
          <span class="the_input">{{ProjectData?.EndDate | date}}</span>
      </h4>
  </div>
  <div class="detail__info">
      <h4 class="label">
          <span class="labels" style="display: block;">Budget</span>
          <span class="the_input">{{ProjectData?.Budget | currency:'NGN':'symbol-narrow'}}</span>
      </h4>
  </div>

  </div>



  </div>
  <h3 class="other_project" *ngIf="status"> Other Project Information</h3>


  </mat-expansion-panel>


            <mat-expansion-panel class="custom-header mat-elevation-z0" hideToggle #example *ngIf="status">
              <mat-expansion-panel-header class="mat-expan">
                <mat-panel-title >
                  Meeting Progress
                </mat-panel-title>

                  <mat-icon *ngIf="!example.expanded">keyboard_arrow_down</mat-icon>
                  <mat-icon *ngIf="example.expanded">keyboard_arrow_right</mat-icon>

              </mat-expansion-panel-header>

              <div class="reference_report_table">
                <div class="" style="text-align: right; width:95%;"><button mat-raised-button class="top_button"(click)="openCreateProgressReportModal()">Add
                        New Progress Report <em class="ti-plus"></em> </button>
                </div>
                <!-- ==============================MAIN TABLE STARTS-===========================MAIN TABLE STARTS====== -->
                <div class="row mt-4 alert alert-success">
                  <div class="col-md-11">

                      <p><em class="ti-info"></em>  Please click on any of the Rows below to view the Detailed Progress Report about the Project under view</p>

                  </div>
                </div>
                <div class="the_edited_progress" #stake>
                  <div class="thead">
                      <span class="head">S/N</span>
                      <span class="head">Report Title</span>
                      <span class="head">Report By</span>
                      <span class="head">Report Date</span>

                      <span class="head">Action</span>
                  </div>

                  <div class="tbody">
                      <div class="td" *ngFor="let master of progressMasterForm.get('ProgressMasters')['controls']; index as i"
                      (click)="openViewProgressMasterReportModal(master)"  style="cursor: pointer;">
                          <span class="head">{{i + 1}}</span>
                          <Span class="head">{{master.value.ReportTitle}}</Span>
                          <Span class="head">{{master.value.ReportedBy}}</Span>
                          <Span class="head">{{master.value.DateReported |date}}</Span>

                          <span
                          ><button
                            class="delete_icon trash"
                            (click)="deleteProgressMaster(i,master.value, $event.stopImmediatePropagation())"
                          >
                            <em class="ti-trash"> </em> </button
                        ></span>
                      </div>
                  </div>

                  <div class="submit">

                    <button type="submit"   class="submit_button" type="submit" (click)="saveReportMaster()" *ngIf="isAddReportMaster">Submit</button>


                   </div>

              </div>
            </div>

            </mat-expansion-panel>
            <mat-expansion-panel (opened)="panelOpenState = true"
                                 (closed)="panelOpenState = false" hideToggle #example2 *ngIf="status" class="mat-elevation-z0">
              <mat-expansion-panel-header class="mat-expan">
                <mat-panel-title>
                  History Progress
                </mat-panel-title>
                <mat-icon *ngIf="!example2.expanded">keyboard_arrow_down</mat-icon>
                <mat-icon *ngIf="example2.expanded">keyboard_arrow_right</mat-icon>

              </mat-expansion-panel-header>
              <div class="reference_report_table" >
                <div class="" style="text-align: right; width:95%;"><button mat-raised-button class="top_button"(click)="openCreateProgressMeetingReportModal()">Add
                        New Meeting Report <em class="ti-plus"></em> </button>
                </div>
                <!-- ==============================MAIN TABLE STARTS-===========================MAIN TABLE STARTS====== -->
                <div class="row mt-4 alert alert-success">
                  <div class="col-md-11">
                      <p><em class="ti-info"></em>  Please click on any of the Rows below to view the Detailed Meeting Report about the Project under view</p>
                  </div>
                </div>
                <div class="the_edited_progress" #stake>
                  <div class="thead">
                      <span class="head">S/N</span>
                      <span class="head">Report Title</span>
                      <span class="head">Report By</span>
                      <span class="head">Report Date</span>

                      <span class="head">Action</span>
                  </div>

                  <div class="tbody">
                      <div class="td" *ngFor="let meeting of progressMeetingForm.get('ProgressMeetings')['controls']; index as i"
                      (click)="openViewProgressMeetingReportModal(meeting)" style="cursor: pointer;">
                          <span class="head">{{i + 1}}</span>
                          <Span class="head">{{meeting.value.MeetingReportTitle}}</Span>
                          <Span class="head">{{meeting.value.ReportedBy}}</Span>
                          <Span class="head">{{meeting.value.DateReported |date}}</Span>

                          <span
                          ><button
                            class="delete_icon trash"
                            (click)="deleteProjectMeeting(i,meeting.value, $event.stopImmediatePropagation())"
                          >
                            <em class="ti-trash"> </em> </button
                        ></span>
                      </div>
                  </div>

                  <div class="submit">

                    <button type="submit"   class="submit_button" type="submit" (click)="saveReportMeeting()" *ngIf="isAddReportMaster">Submit</button>


                   </div>

              </div>
            </div>
            </mat-expansion-panel>
          </mat-accordion>


         </mat-card>
      </div>

      </div>
  </div>
      </div>

  </main>
</div>
